import { Outlet, ScrollRestoration } from 'react-router-dom'

import { ActivateIntercom } from './components/ActivateIntercom.tsx'
import { Favicon } from './components/Favicon/index.tsx'
import { TrackPageView } from './features/analytics/TrackPageView.tsx'

export function Root() {
  return (
    <>
      <Favicon />
      <ActivateIntercom />
      <TrackPageView />
      <ScrollRestoration />
      <Outlet />
    </>
  )
}
